import { Reveal, SectionLabel } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const OnlineAdvantage = () => (
  <section className="relative overflow-hidden px-4 py-16 diag-grid sm:px-8 lg:py-24" data-testid="online-advantage-section">
    <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-[40rem] -translate-x-1/2 rounded-full bg-em1/10 blur-[120px]" />
    <div className="relative z-10 mx-auto max-w-4xl text-center">
      <Reveal>
        <SectionLabel className="justify-center">The Online Advantage</SectionLabel>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
          A 90-Day Live Classroom to{" "}
          <span className="text-em2">Stop Losing and Start Trading With a Plan</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-mutedgreen sm:text-lg">
          No more random videos. No more fake tips. No more figuring it out alone.
          You join live sessions, build your written trading plan with fixed risk,
          then place 10 planned live trades with your mentor reviewing each one.
          Every session is recorded, so nothing is ever missed.
        </p>
        <div className="mt-8 flex justify-center">
          <EligibilityButton size="lg" label="Reserve My Free Trial Seat" testId="online-advantage-cta" />
        </div>
      </Reveal>
    </div>
  </section>
);
